import { safeCombineEpics } from '@cbridge-utils/redux-observable';
import { loadSymbolAssetsEpic } from './_epic/loadSymbolAssets.epic';

export const symbolAssetsEpic = safeCombineEpics(
  loadSymbolAssetsEpic,
);
